// extracted by mini-css-extract-plugin
export default {"heading":"oA-z","corrected":"pA-z","redirectVerbiageContainer":"qA-z","redirectVerbiageText":"rA-z"};